import React, { memo } from 'react';
import ReactTooltip from 'react-tooltip';
import S from './style';

interface Props {
  id: string;
  children: string;
  isForbidden: boolean;
}

const ActionTooltip = memo(function ActionTooltip({
  id,
  children,
  isForbidden,
}: Props) {
  const content = isForbidden
    ? 'Only the creator or the facilitator can perform this action.'
    : children;
  return (
    <ReactTooltip id={id} place="top" effect="solid" border>
      <S.TooltipContent>{content}</S.TooltipContent>
    </ReactTooltip>
  );
});

export { ActionTooltip };
